require('./includePolyfills');
const ssoResources = require('../ssoResources');
const Browser = require('../Payrailz/BrowserClient');

module.exports = Browser(ssoResources);
